import { useEffect, useRef, memo } from "react"

import { insertStyleToIframe } from "shared/utils/iframe"

import { SIframe } from "./styles"

interface PdfViewerProps {
  src: string;
  onLoad: () => void;
}

export const PdfViewer = memo(({ src, onLoad }: PdfViewerProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const styles = [
      'body {background-image: none !important}',
      '#openFile, #viewBookmark {display: none !important}',
      '#secondaryOpenFile, #secondaryDownload, #secondaryViewBookmark {display: none !important}',
      '#secondaryToolbarButtonContainer #firstPage {display: none !important}',
      '#secondaryToolbarButtonContainer #lastPage {display: none !important}',
      '#secondaryToolbarButtonContainer #toggleHandTool {display: none !important}',
      '#secondaryToolbarButtonContainer #documentProperties {display: none !important}',
      '#secondaryToolbarButtonContainer .horizontalToolbarSeparator {display: none !important}',
      '#toolbarViewerLeft {display: none !important}',
      '#toolbarViewerRight {right: 36px !important}',
      '#editorModeButtons {display: none !important}',
      '#editorModeSeparator {display: none !important}',
      '#secondaryToolbarToggle {display: none !important}',
      '.verticalToolbarSeparator {display: none !important}'
    ].join('')

    const applyStyles = () => {
      if (iframeRef?.current?.contentWindow) {
        insertStyleToIframe(iframeRef.current.contentWindow, styles)
      }
    }

    const timeoutId = setTimeout(applyStyles, 300)
    return () => clearTimeout(timeoutId)
  }, [src])

  const handleLoad = () => {
    if (onLoad) onLoad()
  }

  return (
    <SIframe 
      id="pdf-js-viewer"
      src={src}
      title="webviewer"
      frameBorder="0"
      onLoad={handleLoad}
      ref={iframeRef}
    />
  )
})